module.exports = __webpack_public_path__ + "img/img-81.25baf2e6.png";